module.exports = "/work-site/img/record.25965be8.png";